import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  add as addBoardInfo
} from '../redux/boardInfo'

export default function * fetchBoardInfo (action) {
  const { id } = action.payload

  yield put(addBoardInfo({
    id,
    isLoading: true,
    isLoaded: false
  }))

  try {
    const BoardInfo = yield call(apiGetData, 'BoardInfo', { boardId: id })

    yield put(addBoardInfo({
      id: BoardInfo.Id,
      description: BoardInfo.Description,
      creationDate: BoardInfo.CreationDate,
      startDate: BoardInfo.StartDate,
      endDate: BoardInfo.EndDate,
      responsibleUserId: BoardInfo.ResponsibleUserId,
      cardsCount: BoardInfo.CardsCount,
      usersCount: BoardInfo.UsersCount,
      isLoading: false,
      isLoaded: true,
      ...(BoardInfo.EstimatedBudget ? {
        estimatedBudget: {
          value: BoardInfo.EstimatedBudget.Value,
          currency: BoardInfo.EstimatedBudget.Currency,
        }
     } : {})
    }))
  } catch (error) {
    yield put(addBoardInfo({
      id,
      isLoading: false,
      isLoaded: false
    }))
  }
}
